<template>
  <div class="wrap relative">
    <SiteHeader />
    <people-index standalone="true" />
    <SiteFooter />
  </div>
</template>

<script>
// var Sticky = require('sticky-js');
import SiteHeader from '@/components/SiteHeader.vue';
import SiteFooter from '@/components/Footer.vue';
import PeopleIndex from '@/components/PeopleIndex.vue';
export default {
  name: 'CaseStudies',
  components: {
    SiteHeader,
    SiteFooter,
    PeopleIndex
  }
};
</script>

<style lang="scss"></style>
